import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // @ts-ignore - fbq is injected via script
    if (typeof window !== 'undefined' && window.fbq) {
      // @ts-ignore
      window.fbq('track', 'AddToCart', {
        content_name: 'Juega desde Otro Nivel',
        content_category: 'Taller',
        value: 15.0,
        currency: 'USD'
      });
    }
    return true;
  };
  return <a href="https://coneckta.co/taller-juegadesdeotronivel" target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`bg-accent text-white rounded-md px-10 py-4 font-sans font-bold uppercase tracking-wide text-center inline-block transition-all hover:shadow-lg hover:-translate-y-0.5 ${className}`} data-id="element-66">
      {children}
    </a>;
}